import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import translate from 'components/hoc/translate';
import utils from 'helpers/utils';

const TextFieldWrapper = styled.div`
    margin: 0 0 20px 0;
`;

const Label = styled.div`
    margin-bottom: 3px;
    font-size: 14px;
    line-height: 1.2;
    font-weight: bold;
`;

const Text = styled.div`
    font-size: 16px;
    line-height: 1.2;
`;

const ComputedPriceField = (props) => {
    const {
        currency,
        label,
        locale,
        translate,
        value,
    } = props;

    if (utils.isEmpty(value)) {
        return null;
    }

    return (
        <TextFieldWrapper>
            { label &&
                <Label>{ translate(label) || '...' }</Label>
            }

            <Text>{ utils.formatPrice(value, currency, locale) }</Text>
        </TextFieldWrapper>
    );
};

ComputedPriceField.propTypes = {
    currency: PropTypes.string,
    label: PropTypes.string,
    locale: PropTypes.string.isRequired,
    translate: PropTypes.func.isRequired,
    value: PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.string,
    ]).isRequired,
};

export default translate(ComputedPriceField);



// WEBPACK FOOTER //
// ./src/components/show/ComputedPriceField.js